import User from "./User";

const Config = (() => {
  let serverURL = "https://dashboard.chuyenkhoan.com/dashboard";
  let paymentServerURL = "https://thanhtoan.chuyenkhoan.com/pay/v1?";
  let checkoutServerURL = "https://thanhtoan.chuyenkhoan.com/checkout/v1/ckpay.html?";
  let captchaKey = "6Lf1BnAbAAAAAArtvApk63cl7lez_PezrAZnq41L";
  let availableBanks = [];

  const getServerURL = () => serverURL;
  const getServerRestURL = (service, path) =>
    `${serverURL}/api/v2/${service}/${User.getActivePartner()}${path ? `/${path}` : ""}`;

  const getServerPartnerURL = (path) => getServerRestURL("partners", path);
  const getServerTransactionURL = (path) => getServerRestURL("transactions", path);
  const getServerOrderURL = (path) => getServerRestURL("orders", path);
  const getServerStaffURL = (path) => getServerRestURL("staffs", path);
  const getServerCustomerURL = (path) => getServerRestURL("customers", path);
  const getServerProductURL = (path) => getServerRestURL("products", path);
  const getServerConfigURL = (path) => getServerRestURL("config", path);
  const getServerPartnerAdminURL = (path) => getServerRestURL("admins", path);
  const getServerOriginAdminURL = (path) =>
    `${serverURL}/api/v2/origin${path ? `/${path}` : ""}`;

  const setServerURL = (url) => (serverURL = url);
  const getPaymentServerURL = () => paymentServerURL;
  const setPaymentServerURL = (url) => (paymentServerURL = url);
  const getCheckoutServerURL = () => checkoutServerURL;
  const setCheckoutServerURL = (url) => (checkoutServerURL = url);
  const getCaptchaKey = () => captchaKey;
  const setCaptchaKey = (key) => (captchaKey = key);
  const getAvailableBanks = () => availableBanks;
  const setAvailableBanks = (bankList) => (availableBanks = bankList);

  const isSuperAdmin = (email) =>
    email === "hoangtronghuy@gmail.com" || email === "huy@chuyenkhoan.com";
  const isInternal = (userObj) => userObj.partnerId === 10001;
  const isStandalone = () => !!window.ckDashboardTitle;

  return {
    getServerURL,
    getServerRestURL,
    getServerPartnerURL,
    getServerTransactionURL,
    getServerOrderURL,
    getServerStaffURL,
    getServerCustomerURL,
    getServerProductURL,
    getServerConfigURL,
    getServerPartnerAdminURL,
    getServerOriginAdminURL,
    setServerURL,
    getPaymentServerURL,
    setPaymentServerURL,
    getCheckoutServerURL,
    setCheckoutServerURL,
    getCaptchaKey,
    setCaptchaKey,
    getAvailableBanks,
    setAvailableBanks,
    isSuperAdmin,
    isInternal,
    isStandalone,
  };
})();

export default Config;
